var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input-vuetify',{staticStyle:{"width":"70%","padding-top":"0.6rem"},attrs:{"preferred-countries":['es', 'us' ],"valid-characters-only":true,"error":!_vm.isValid},on:{"input":_vm.onInput,"enter":_vm.addText}})}
var staticRenderFns = []

export { render, staticRenderFns }